import type { Client, Place, Project } from ".";

export enum RouterViewModeType {
  NONE,
  CLIENT = "clientView",
  PLACE = "placeView",
  PROJECT = "projectView",
}

export interface RouterViewMode {
  type: RouterViewModeType;
  currentEntityId: string;
  source: string;
  client?: Client;
  place?: Place;
  project?: Project;
}
